export default {
  "b2b.zdroje-grid-columns.id.label": "Id",
  "b2b.zdroje-grid-columns.nazev.label": "Název",
  "b2b.zdroje-grid-columns.popis.label": "Popis",
  "b2b.zdroje-grid-columns.exkluzivita.label": "Exkluzivní",
  "b2b.zdroje-grid-columns.maxPocetPozadavku.label": "Max. počet požadavků",
  "b2b.zdroje-grid-columns.pozadavekSmena.label": "Směnový"
};
